import React from 'react';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';

export const integrationIcon = (
  value: boolean,
  selected: string,
  disabled: string
) => (
  <SettingsEthernetIcon
    style={{ width: '21', marginLeft: '-3px', marginRight: '-3px', color: value ? selected : disabled }}
    id="iconMenu-icon-integration"
  />
);
